// frontend/src/components/ProtectedRoute.js
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Spinner } from 'react-bootstrap'; // Assuming react-bootstrap is installed and used

const ProtectedRoute = ({ children }) => {
    const { isAuthenticated, isLoading } = useAuth();

    if (isLoading) {
        // You can render a loading spinner or a blank page while authentication status is being determined
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                <Spinner animation="border" role="status">
                    <span className="visually-hidden">Loading...</span>
                </Spinner>
            </div>
        );
    }

    if (!isAuthenticated) {
        // User is not authenticated, redirect to login page
        return <Navigate to="/login" replace />;
    }

    return children;
};

export default ProtectedRoute;
